const OrganicShape = ({ className = "", variant = "primary", children }) => {
  const variants = {
    primary: "bg-gradient-organic",
    secondary: "bg-pastel-blue",
    accent: "bg-pastel-purple",
  };

  return (
    <div
      className={`
        ${variants[variant]} 
        rounded-organic 
        shadow-organic 
        transition-organic 
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default OrganicShape;
